import { ExamItem, ExamResult } from '@/app/exam/ui/exam-dashboard-types';
import { getPageLocationByHref } from '@/app/shared/utils/route-utils';
import { VueRouter } from 'vue-router/types/router';
import i18n from '@/plugins/i18n'

export const examsDashboardTableMixin = {
  methods: {
    examCompleted(exam: ExamItem|ExamResult): boolean {
      return exam.status === 'completed';
    },

    gradingMethodLabel(exam: ExamItem): string {
      return exam.gradingMethod === 'highest-grade' ? i18n.t('dashboard.highest_score').toString() : 
        i18n.t('dashboard.last_attempt').toString();
    },

    getExamResultPercent(examResult: ExamResult): number {
      if (examResult.status === 'not-attempted') {
        return 0;
      }

      return examResult.effectiveAttempt.score.percent;
    },

    onButtonClicked(exam: ExamItem, router: VueRouter): void {
      const location = getPageLocationByHref(exam.href as string);
      router.push(location);
    }
  }
};
